export default "__VITE_ASSET__b8def6fe__"